<template>
  <div v-if="!showGetStarted" class="uyh-share-container" id="share">
    <div class="uyh-back">
      <router-link :to="returnLink()">
        <svg svg-inline="" class="uyh-back-arrow js-back" role="presentation" focusable="false" width="19" height="30" viewBox="0 0 19 30" xmlns="http://www.w3.org/2000/svg"><path d="M15.882 30L0 15 15.882 0l3.065 2.896L6.131 15l12.816 12.103z" fill="#21362C" fill-rule="evenodd"/></svg><span>{{ $t('navigation.back') }}</span>
      </router-link>
    </div>
    <StepInfo :step="'3'" :totalSteps="'3'" :message="$t('step_nav.step_2')"/>
    <div class="share-content">
      <div class="uyh-share-img-wrapper">
        <img id="uyh-share-img">
      </div>

      <div class="uyh-share-actions">
        <p class="share-message" v-html="$t('share.message')"></p>
        <hr />
        <p>{{ $t('share.device_save') }}</p>
        <a href="" @click="instagramShare" download="loveinspades.png" class="uyh-share-btn" id="instagram-download" target="_blank">
          <div class="uyh-social-icon">
            <img src="@/assets/icons/instagram.png">
          </div>
          <p>{{ $t('share.instagram') }}</p>
          <svg svg-inline="" role="presentation" focusable="false" xmlns="http://www.w3.org/2000/svg" width="16" height="21" viewBox="0 0 16 21"><path d="M13.597 6.572l-4.872 4.872V0H6.458v11.444L1.587 6.572 0 8.158l7.592 7.592 7.592-7.592zM.565 18.194h14.564v2.1H.565z" fill="#223628" fill-rule="evenodd"/></svg>
        </a>
        <hr class="hide-tablet-up"/>

        <p>{{ $t('share.share_to') }}</p>
        <a v-on:click="facebookUrl" class="uyh-share-btn" target="_blank">
          <div class="uyh-social-icon">
            <img src="@/assets/icons/facebook.png">
          </div>
          <p>{{ $t('share.facebook') }}</p>
          <svg svg-inline="" class="right" role="presentation" focusable="false" width="19" height="30" viewBox="0 0 19 30" xmlns="http://www.w3.org/2000/svg"><path d="M15.882 30L0 15 15.882 0l3.065 2.896L6.131 15l12.816 12.103z" fill="#21362C" fill-rule="evenodd"/></svg>
        </a>
        <a v-on:click="twitterUrl" class="uyh-share-btn" target="_blank">
          <div class="uyh-social-icon">
            <img src="@/assets/icons/twitter.png">
          </div>
          <p>{{ $t('share.twitter') }}</p>
          <svg svg-inline="" class="right" role="presentation" focusable="false" width="19" height="30" viewBox="0 0 19 30" xmlns="http://www.w3.org/2000/svg"><path d="M15.882 30L0 15 15.882 0l3.065 2.896L6.131 15l12.816 12.103z" fill="#21362C" fill-rule="evenodd"/></svg>
        </a>
        <a v-on:click="pinterestUrl" class="uyh-share-btn no-border" target="_blank">
          <div class="uyh-social-icon">
            <img src="@/assets/icons/pinterest.png">
          </div>
          <p>{{ $t('share.pinterest') }}</p>
          <svg svg-inline="" class="right" role="presentation" focusable="false" width="19" height="30" viewBox="0 0 19 30" xmlns="http://www.w3.org/2000/svg"><path d="M15.882 30L0 15 15.882 0l3.065 2.896L6.131 15l12.816 12.103z" fill="#21362C" fill-rule="evenodd"/></svg>
        </a>

        <router-link to="next-steps" class="next-steps">{{ $t('navigation.next') }}</router-link>
      </div>
    </div>
  </div>

  <div v-else-if="showGetStarted">
    <GetStarted/>
  </div>
</template>

<script>
  import StepInfo from '@/components/Global_StepInfo.vue'
  import GetStarted from '@/components/Landing_GetStarted.vue'
  import getCookie from '@/assets/javascripts/get_cookie'

  export default {
    components: {
      StepInfo,
      GetStarted
    },
    data: function() {
      return {
        showGetStarted: false
      }
    },
    beforeMount: function () {
      this.$store.dispatch('updateShare', true);
      this.$store.dispatch('updateMantrapage', false);
    },
    methods: {
      facebookUrl: function(e) {
        e.preventDefault();
        var url = encodeURIComponent(getCookie('shareurl'));
        var facebook = "https://www.facebook.com/dialog/share?app_id=918716194955007&display=popup&href=" + url + "&hashtag=%23loveinspades";
        this.windowPopup(facebook, 850, 750);
        this.trackShare('facebook');
      },
      twitterUrl: function(e) {
        e.preventDefault();
        var url = encodeURIComponent(getCookie('shareurl'));
        var twitter = "https://twitter.com/intent/tweet/?url=" + url + "&hashtags=loveinspades";
        this.windowPopup(twitter, 750, 295);
        this.trackShare('twitter');
      },
      pinterestUrl: function(e) {
        e.preventDefault();
        var img = getCookie('staticimage');
        var url = encodeURIComponent(getCookie('shareurl'));
        var pinterest = "https://www.pinterest.com/pin/create/button/?url=" + url + "%2F&media=" + img + "&hashtags=loveinspades";
        this.windowPopup(pinterest, 800, 850);
        this.trackShare('pinterest');
      },
      instagramShare: function() {
        this.trackShare('instagram');
      },
      trackShare: function(type) {
        window.dataLayer.push({
          'event': 'share-click',
          'social': type,
          'locale': getCookie('lang'),
          'template': getCookie('template'),
          'mantra': getCookie('mantraid')
        });
      },
      windowPopup: function(url, width, height) {
        // Calculate the position of the popup so
        // it’s centered on the screen.
        var left = (screen.width / 2) - (width / 2),
            top = (screen.height / 2) - (height / 2);

        window.open(
          url,
          "",
          "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=" + width + ",height=" + height + ",top=" + top + ",left=" + left
        );
      },
      returnLink: function() {
        var params = getCookie('mantra');
        var mantraId = getCookie('mantraid');
        var resource = getCookie('resource');
        var url = 'send-message/' + mantraId + '/' + resource + '?' + params;
        return url;
      }
    },
    mounted: function() {
      var image = document.getElementById('uyh-share-img');
      var instaDownload = document.getElementById('instagram-download');
      var src = getCookie('staticimage');
      if (src) {
        image.setAttribute('src', src);
        instaDownload.setAttribute('href', src);
      } else {
        this.showGetStarted = true;
      }
      this.$emit('loader-inactive');
    }
  }
</script>

<style lang="scss" scoped>
  .responsivesite #wrapper #uyh-app,
  #uyh-app {
    .uyh-share-container {
      $mobile-breakpoint: 767px;
      $tablet-portrait-down-breakpoint: 1023px;
      $tablet-down-breakpoint: 1199px;
      $tablet-breakpoint: 1200px;
      $hd-desktop-breakpoint: 1280px;

      .share-content {
        display: flex;
        justify-content: center;
        padding-bottom: 40px;
        .uyh-share-img-wrapper,
        .uyh-share-actions {
          margin: 0 25px;
        }
        .uyh-share-img-wrapper {
          flex: 0 0 40%;
          img {
            box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.5);
            max-width: 640px;
            width: 100%;
          }
        }
        .uyh-share-actions {
          flex: 0 0 30%;
          p {
            font-size: 20px;
            line-height: 1.4;
            margin-bottom: 0;
            margin-top: 40px;
            &.share-message {
              margin: 0;
            }
          }
          hr {
            border-style: solid;
            color: #CEB6BA;
            margin: 40px 0 0;
            &.hide-tablet-up {
              display: none;
            }
          }
          .uyh-share-btn {
            align-items: center;
            background-color: transparent;
            border: 0;
            border-bottom: 1px #CEB6BA solid;
            border-radius: 0;
            cursor: pointer;
            display: flex;
            font-size: 18px;
            justify-content: space-between;
            margin: 0 auto;
            max-height: none;
            padding: 22px 0;
            width: 71.5%;
            &:after {
              display: none;
            }
            &.no-border {
              border-bottom: 0;
            }
            .right {
              height: 18px;
              transform: rotate(180deg);
            }
            .uyh-social-icon {
              flex: 0 0 33px;
              margin-right: 21px;
              height: 33px;
              img {
                margin: 0 auto;
                max-height: 100%;
                max-width: 100%;
                width: auto;
              }
            }
            p {
              font-size: 18px;
              line-height: 1;
              margin: 0;
              text-align: left;
              width: 100%;
            }
          }
          .next-steps {
            font-size: 20px;
            letter-spacing: 1px;
            padding-top: 40px;
          }
        }
      }
    }

    // Portrait tablet breakpoint
    @media screen and (max-width: 1023px) {
      .uyh-share-container {
        .share-content {
          flex-wrap: wrap;
          .uyh-share-img-wrapper,
          .uyh-share-actions {
            flex: 0 0 60%;
            margin: 0 auto;
          }
          .uyh-share-actions {
            padding-top: 35px;
            p {
              margin-bottom: 10px;
              margin-top: 23px;
            }
            hr {
              margin: 23px 0 0;
              &.hide-tablet-up {
                display: block;
                margin: 23px 0 0;
              }
            }
            .uyh-share-btn {
              border: none;
              padding: 10px 0;
              .uyh-social-icon {
                flex: 0 0 25px;
                height: 25px;
              }
            }
            .next-steps {
              padding-top: 34px;
            }
          }
        }
      }
    }

    // Mobile
    @media screen and (max-width: 767px) {
      .uyh-share-container {
        .share-content {
          .uyh-share-img-wrapper,
          .uyh-share-actions {
            flex: 0 0 100%;
            margin-top: 23px;
            padding: 0 20px;
          }

          .uyh-share-actions {
            .uyh-share-btn {
              width: 100%;
            }
            .next-steps {
              padding-top: 25px;
            }
          }
        }
      }
    }
  }
</style>
